function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    @media (min-width: ",
        ") {\n      ",
        "\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    @media (min-width: ",
        ") {\n      ",
        "\n    }\n  "
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n    @media (min-width: ",
        ") {\n      ",
        "\n    }\n  "
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n    @media (min-width: ",
        ") {\n      ",
        "\n    }\n  "
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  width: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  padding: ",
        ";\n  border: 1.5px solid ",
        ";\n  border-radius: 0.75rem;\n  background: var(--theme-input-bg, #fff);\n  color: var(--theme-text, #111827);\n  font-size: 1rem;\n  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n  outline: none;\n  &:focus {\n    border-color: var(--theme-primary, #3b82f6);\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);\n  }\n  &:disabled {\n    background: var(--theme-input-disabled-bg, #f3f4f6);\n    color: var(--theme-text-disabled, #a1a1aa);\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  left: 0.85rem;\n  top: ",
        ";\n  transform: translateY(0);\n  font-size: ",
        ";\n  color: ",
        ";\n  background: var(--theme-input-bg, #fff);\n  padding: 0 0.25rem;\n  pointer-events: none;\n  transition: top 0.2s ease-in-out, font-size 0.2s ease-in-out, color 0.2s ease-in-out;\n  z-index: 2;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.85rem;\n  color: var(--theme-text-secondary, #a1a1aa);\n  margin-top: 0.1rem;\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.85rem;\n  color: var(--theme-error, #ef4444);\n  margin-top: 0.1rem;\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.8rem;\n  color: ",
        ";\n  margin-left: auto;\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
import { css } from '@emotion/react';
// 미디어 쿼리 브레이크포인트
var breakpoints = {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px'
};
// 미디어 쿼리 헬퍼 함수
var media = {
    sm: function(styles) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return css(_templateObject(), breakpoints.sm, css.apply(void 0, [
            styles
        ].concat(_to_consumable_array(args))));
    },
    md: function(styles) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return css(_templateObject1(), breakpoints.md, css.apply(void 0, [
            styles
        ].concat(_to_consumable_array(args))));
    },
    lg: function(styles) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return css(_templateObject2(), breakpoints.lg, css.apply(void 0, [
            styles
        ].concat(_to_consumable_array(args))));
    },
    xl: function(styles) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return css(_templateObject3(), breakpoints.xl, css.apply(void 0, [
            styles
        ].concat(_to_consumable_array(args))));
    }
};
export var InputContainer = styled.div(_templateObject4(), function(param) {
    var $fullWidth = param.$fullWidth;
    return $fullWidth ? '100%' : 'auto';
});
export var StyledInput = styled.input(_templateObject5(), function(param) {
    var $hasLabel = param.$hasLabel;
    return $hasLabel ? '1.6rem 0.75rem 0.5rem 0.75rem' : '0.75rem 0.75rem 0.5rem 0.75rem';
}, function(param) {
    var $hasError = param.$hasError;
    return $hasError ? 'var(--theme-error, #ef4444)' : 'var(--theme-border, #d1d5db)';
});
export var FloatingLabel = styled.label(_templateObject6(), function(param) {
    var $focused = param.$focused, $hasValue = param.$hasValue;
    return $focused || $hasValue ? '0.32rem' : '1.1rem';
}, function(param) {
    var $focused = param.$focused, $hasValue = param.$hasValue;
    return $focused || $hasValue ? '0.78rem' : '1rem';
}, function(param) {
    var $focused = param.$focused, $hasValue = param.$hasValue, $hasError = param.$hasError;
    return $hasError ? 'var(--theme-error, #ef4444)' : $focused || $hasValue ? 'var(--theme-primary, #3b82f6)' : 'var(--theme-text-placeholder, #9ca3af)';
});
export var DescriptionText = styled.div(_templateObject7());
export var ErrorMessage = styled.div(_templateObject8());
export var CharacterCount = styled.div(_templateObject9(), function(param) {
    var $hasError = param.$hasError;
    return $hasError ? 'var(--theme-error, #ef4444)' : 'var(--theme-text-placeholder, #a1a1aa)';
});
